import Card from "../../Card";
import React from "react";
import {Animated} from "react-native";
import {useWallet} from "use-wallet";
import styled from "styled-components";
import {getBalanceNumber} from "../../../utils/formatBalance";
import BigNumber from "bignumber.js";
import {Hide} from "../../../views/Stake/components/stake_list";


export const AccountWidget:React.FC = ()=>{

    const {account,balance} = useWallet();


    return (
        <div>
            {
                account ?  <StyleWap>
                            <StyleBalance>ETH: {getBalanceNumber(new BigNumber(balance)).toFixed(2)}</StyleBalance>
                            <StyleAccount>{account.substring(0,3) +'...'+ account.substring(37)}</StyleAccount>
                </StyleWap> : <></>
            }

        </div>
    );
};


const StyleWap = styled.div`
 

  background: rgb(64, 68, 79);
  border-radius: 8px;
  display: flex;
  flex: 1;
  
  border: 1px solid rgb(64, 68, 79);
justify-content: center;
align-items: center;
color: #FFFFFF;
font-size:12px ;
@media (max-width: 768px) {
    display:none !important;
  }

`;



const StyleAccount = styled.div`
padding: 10px;
background-color: rgb(44, 47, 54);
border-radius: 8px;
`;
const StyleBalance= styled.div`
padding: 10px;
color: #FFFFFF;
`;



